/**
 * Stage 0D — the parking layout's typed refusals, in words an administrator
 * can act on. The database refuses to delete or deactivate a spot with a
 * vehicle in it (SPOT_OCCUPIED) and, from the legacy layout editor, a spot
 * that mirrors a Facility Editor parking bay (SPOT_MANAGED_BY_FACILITY_EDITOR).
 * Either way the save wrote nothing.
 */
export function layoutSaveRefusalMessage(message: string | undefined): string {
  const m = message ?? '';
  const quoted = /"([^"]+)"/.exec(m)?.[1];
  const spot = quoted ? `Spot ${quoted}` : 'A spot';
  if (m.startsWith('SPOT_OCCUPIED')) {
    return `${spot} has a vehicle in it. Move the vehicle before removing the spot. Nothing was saved.`;
  }
  if (m.startsWith('SPOT_MANAGED_BY_FACILITY_EDITOR')) {
    return `${spot} is a parking bay managed in the Facility Editor. Remove it there. Nothing was saved.`;
  }
  return m || 'Failed to save parking spots';
}
